define('views/modules/profile/edit/preferences-edit-form-personal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'bootbox',
    // services
    'services/i18n',
    'services/session',
    'services/user',
    'services/api',
    'services/toastr-service',
    // events
    'services/events/user-events',
    // collections
    'collections/member/groups',
    'collections/calendar/personal-data/personal-data-types',
    // views
    'views/parts/form/textbox',
    'views/parts/form/select',
    'views/parts/form/datepicker',
    'views/parts/form/choices',
    'views/parts/info-section',
    'views/parts/form/button',
    'views/parts/feedback/feedback-button',
    // templates
    'text!templates/modules/profile/edit/preferences-edit-form-personal.html',
], function (
    // Libs
    _, Backbone, Mustache, U, Bootbox,
    // services
    i18n,
    Session,
    User,
    API,
    ToastrService,
    // events
    UserEvents,
    // collections
    CGroups,
    CPersonalDataTypes,
    // views
    VTextBox,
    VSelect,
    VDatePicker,
    VChoices,
    VInfoSection,
    VButton,
    VFeedbackButton,
    // templates
    TPreferencesEditFormPersonal
) {

    var VPreferencesEditFormPersonal = Backbone.View.extend({
        template: TPreferencesEditFormPersonal,

        regions: {
            root: '.personal-info-edit',
            lengthUnit: '.length-unit-input',
            weightUnit: '.weight-unit-input',
            distanceUnit: '.distance-unit-input',
            privateMessageEmail: '.private-message-email-input',
            clientRecapEmail: '.client-recap-email-input',
            clientActivatedEmail: '.client-activated-email-input',
            mainGroup: '.main-group-input',
            uncompletedExerciseNotification: '.uncompleted-exercise-push-notification',
            newActivityCreatedNotification: '.new-activity-created-push-notification',
            zoomIntegration: '.zoom-integration',
            garminIntegration: '.garmin-integration',
        },

        initialize: function (opt) {
            this.options = opt || {};

            var model = this.model,
                collection = this.collection = new CGroups(null, {removeExpired: true});

            this.personalDataTypes = new CPersonalDataTypes();

            this.view = {
                info: new VInfoSection({
                    title: "Preferences",
                    //help: "messages:helpbox-preferences-edit",
                    content: this.template,
                }),
                mainGroup: new VSelect({
                    option: {label: 'name', value: 'id'},
                    model: model,
                    attribute: 'mainGroup',
                    collection: collection,
                    context: this,
                }),
                lengthUnit: new VChoices({
                    model: model,
                    radio: true,
                    styleButton: true,
                    // groupLabel: 'Length unit',
                    addClass: 'btn-group-sm',
                    attribute: 'lengthUnit',
                    onChange: this.onLengthUnitChange,
                    labelposition: "top",
                    context: this,
                    choices: [
                        {label: 'in', value: 'in'},
                        {label: 'cm', value: 'cm'}
                    ]
                }),
                weightUnit: new VChoices({
                    model: model,
                    radio: true,
                    styleButton: true,
                    addClass: 'btn-group-sm',
                    // groupLabel: 'Weight unit',
                    attribute: 'weightUnit',
                    labelposition: "top",
                    context: this,
                    choices: [
                        {label: 'lbs', value: 'lbs'},
                        {label: 'kg', value: 'kg'}
                    ]
                }),
                distanceUnit: new VChoices({
                    model: model,
                    radio: true,
                    styleButton: true,
                    addClass: 'btn-group-sm',
                    // groupLabel: 'Distance unit',
                    attribute: 'distanceUnit',
                    labelposition: "top",
                    context: this,
                    choices: [
                        {label: 'km', value: 'km'},
                        {label: 'mi', value: 'mi'}
                    ]
                }),
                privateMessageEmail: new VChoices({
                    model: model,
                    label: 'Receive e-mail notification when I receive a private message',
                    attribute: 'privateMessageEmail',
                    labelposition: "top",
                    context: this,
                }),
                clientRecapEmail: new VChoices({
                    model: model,
                    label: 'Receive weekly recap of my client by e-mail',
                    attribute: 'clientRecapEmail',
                    labelposition: "top",
                    context: this,
                }),
                clientActivatedEmail: new VChoices({
                    model: this.model,
                    label: 'Receive e-mail notification when a client activate his account',
                    attribute: 'clientActivatedEmail',
                    labelposition: "top",
                    context: this,
                }),
                uncompletedExerciseNotification: new VChoices({
                    model: model,
                    label: 'Uncompleted exercises notification details',
                    attribute: 'uncompletedExerciseNotification',
                    labelposition: "top",
                    context: this,
                }),
                newActivityCreatedNotification: new VChoices({
                    model: model,
                    label: 'settings:new-activity-created-notification-label',
                    attribute: 'newActivityCreatedNotification',
                    labelposition: "top",
                    context: this,
                }),
                zoomIntegrationLogin: new VButton({
                    label: "settings:login-with-zoom",
                    callback: this.zoomLoginCallback,
                    context: this,
                    icon: false,
                }),
                zoomIntegrationLogout: new VButton({
                    label: "settings:logout-zoom",
                    callback: this.zoomLogoutCallback,
                    context: this,
                    icon: false,
                }),
                garminIntegrationLogin: new VButton({
                    label: "settings:login-with-garmin",
                    callback: this.garminLoginCallback,
                    context: this,
                    icon: false,
                }),
                garminIntegrationLogout: new VButton({
                    label: "settings:logout-garmin",
                    callback: this.garminLogoutCallback,
                    context: this,
                    icon: false,
                })
            };

            this.listenTo(collection, 'sync', this.onCollectionSync);
        },
        render: function () {
            // append the form
            this.assign(this.view.info, this.$el)
                .generateZones();

            var view = this.view,
                zone = this.zone;

            this.assign(view.mainGroup, zone.$mainGroup)
                .assign(view.lengthUnit, zone.$lengthUnit)
                .assign(view.weightUnit, zone.$weightUnit)
                .assign(view.distanceUnit, zone.$distanceUnit)
                .assign(view.privateMessageEmail, zone.$privateMessageEmail)
                .assign(view.clientRecapEmail, zone.$clientRecapEmail)
                .assign(view.clientActivatedEmail, zone.$clientActivatedEmail)
                .assign(view.uncompletedExerciseNotification, zone.$uncompletedExerciseNotification)
                .assign(view.newActivityCreatedNotification, zone.$newActivityCreatedNotification);

            if (User.get('zoomPersonalMeetingId')) {
                this.assign(view.zoomIntegrationLogout, zone.$zoomIntegration);
            } else {
                this.assign(view.zoomIntegrationLogin, zone.$zoomIntegration);
            }

            if (User.get('garminAccessToken')) {
                this.assign(view.garminIntegrationLogout, zone.$garminIntegration);
            } else {
                this.assign(view.garminIntegrationLogin, zone.$garminIntegration);
            }

            // Display intercom links based on user language
            if (i18n.language.includes('fr')) {
                Backbone.$('#zoom-link').attr('href', 'https://intercom.help/totalcoaching/en/articles/3961246-seances-live-avec-tes-clients-en-utilisant-zoom');
                Backbone.$('#garmin-link').attr('href', 'https://intercom.help/totalcoaching/en/articles/4400070-importer-les-donnees-garmin');
            } else {
                Backbone.$('#zoom-link').attr('href', 'https://intercom.help/totalcoaching/en/articles/3961120-conduct-live-sessions-with-your-clients-using-zoom');
                Backbone.$('#garmin-link').attr('href', 'https://intercom.help/totalcoaching/en/articles/4400049-import-garmin-data-automatically');
            }

            if (User.getMainGroup().isSupervisor === false) {
                this.$el.find('#supervisor-notifications').hide();
                this.$el.find('#supervisor-integrations').hide();
            }

            this.collection.fetch();
            this.personalDataTypes.fetch({remove: false});

            return this;
        },

        onLengthUnitChange: function (model, value) {
            model.set('heightUnit', value);
            model.convertHeightTo(value);
        },

        onCollectionSync: function (collection) {
            this.zone.$mainGroup.toggle(collection.length > 1);
            this.view.mainGroup.setValue(this.model.getMainGroupId());
        },

        zoomLogoutCallback: function () {
            var self = this
            User.save({ zoomPersonalMeetingId: '' }, { patch: true }).then(function() {
                ToastrService.success('zoom-disconnect-success');
                UserEvents.zoomUpdated();
            });
        },

        garminLogoutCallback: function() {
            var self = this;
            Backbone.ajax({
                url: API.url('/garmin/disconnect'),
                method: 'DELETE',
                success: function () {
                    self.trigger('disconnected');
                    ToastrService.success('zoom-disconnect-success');
                },
                error: function () {
                    ToastrService.error('we-encountered-a-problem-with-zoom-logout');
                }
            })
        },

        zoomLoginCallback: function () {
            var self = this
            Bootbox.prompt({
                title: i18n.t('paste-your-pmi'),
                placeholder: 'ie: 682 278 2812',
                callback: function(result) {
                    if (result) {
                        var id = result.replaceAll(' ', '').replaceAll('-', '')
                        User.save({ zoomPersonalMeetingId: id }, { patch: true }).then(function() {
                            ToastrService.success('zoom-login-success');
                            UserEvents.zoomUpdated();
                        });
                    }
                }
            });
        },

        garminLoginCallback: function () {
            var url = 'garmin/login?user=' + User.id;
            var self = this;
            var fullUrl = API.url(url);

            // Use Capacitor Browser for in-app browser with OAuth callback handling
            if (window.Capacitor && window.Capacitor.Plugins.Browser && window.Capacitor.isNativePlatform()) {
                var Browser = window.Capacitor.Plugins.Browser;
                
                Browser.open({ url: fullUrl }).then(function() {
                    // Listen for browser finished (when user closes it or OAuth completes)
                    Browser.addListener('browserFinished', function() {
                        // Check if user completed OAuth by fetching user data
                        User.fetch({ force: true }).then(function() {
                            if (User.get('garminAccessToken')) {
                                ToastrService.success('connection-successful');
                                self.trigger('connected');
                            }
                        });
                    });
                }).catch(function(error) {
                    console.error('Failed to open browser:', error);
                    ToastrService.error('we-encountered-a-problem-with-garmin-login');
                    if (window.Rollbar) {
                        window.Rollbar.error(error);
                    }
                });
            } else {
                // Fallback to window.open for web
                window.open(fullUrl, "_system");
            }
        },

    });

    return VPreferencesEditFormPersonal;
});

